// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-1L7xI";
var _5 = "messages-2xR2H";
var _6 = "passenger-hRu8p";
var _7 = "footer-1Rdl3";
var _8 = "button-32978";
var _9 = "header__number-21HDK";
var _a = "group__container-2sKJe";
var _b = "group__container__icon-fbyQr";
var _c = "group__container_identity-1P3Vf";
var _d = "group__container_documents-35nSd";
var _e = "scrollBody-jv3bM";
var _f = "paper-27QV0";
var _10 = "header__container-1TN4_";
var _11 = "header__container_filled-8ojiQ";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "messages", _6 as "passenger", _7 as "footer", _8 as "button", _9 as "header__number", _a as "group__container", _b as "group__container__icon", _c as "group__container_identity", _d as "group__container_documents", _e as "scrollBody", _f as "paper", _10 as "header__container", _11 as "header__container_filled" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "messages": _5, "passenger": _6, "footer": _7, "button": _8, "header__number": _9, "group__container": _a, "group__container__icon": _b, "group__container_identity": _c, "group__container_documents": _d, "scrollBody": _e, "paper": _f, "header__container": _10, "header__container_filled": _11 }
